// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"591":"7c9b73fb","695":"7c9b73fb","855":"0afc4951"}[chunkId] + ".chunk.css";
};